<template>
  <div>
    <div>

    </div>
    <div>
        <section v-if="!initialLoading">
        <div class="row">
            <div class="col-12">
              <div class="table-responsive">
                  <table
                  id="data-table-list-courses"
                  class="table-hover-animation table-striped table-bordered"
                  style="width:100%"
                  >
                    <thead>
                        <tr>
                          <th>Nombres</th>
                          <th>Apellidos</th>
                          <th>Nro. documento</th>
                          <th>Certificado</th>
                          <th>Codigo</th>
                          <th style="width:13%">Acción</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="cliente in clientes" :key="cliente.id">
                          <td>{{cliente.name}}</td>
                          <td>{{cliente.lastname}}</td>
                          <td>{{cliente.num_doc}}</td>
                          <td>{{cliente.name_certificate}}</td>
                          <td>{{cliente.cod_certificate}}</td>
                          <td>
                            <el-button @click="editModal(cliente)" type="primary"><el-icon><Edit /></el-icon></el-button>
                            <el-button @click="deleteModal(cliente)" type="danger"><el-icon><Delete /></el-icon></el-button>
                          </td>
                        </tr>
                    </tbody>
                  </table>
              </div>
            </div>
        </div>
        </section>
        <custom-spinner v-else></custom-spinner>
    </div>

    <!-- modal -->
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="exampleModalLabel">Editar datos de usuario</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="submit" id="upload" enctype="multipart/form-data" method="post">
            <div class="row">
                <div class="mb-3 col-12">
                  <label for="" class="form-label">Nombres: </label>
                  <input type="text" v-model="selected.name" class="form-control">
                </div>
                <div class="mb-3 col-12">
                  <label for="" class="form-label">Apellidos: </label>
                  <input type="text" v-model="selected.lastname" class="form-control">
                </div>
                <div class="mb-3 col-12">
                    <label for="" class="form-label">Tipo de documento: </label>
                    <select v-model="selected.doc_type_id" class="form-select form-select-lg">
                        <option selected>Select one</option>
                        <option v-for="document_type in this.courseCategory" :value="document_type.id" :key="document_type.id">{{document_type.name}}</option>
                    </select>
                </div>
                <div class="mb-3 col-12">
                  <label for="" class="form-label">Nro. de documento: </label>
                  <input type="text"  v-model="selected.num_doc" class="form-control" placeholder="">
                </div>
                <div class="mb-3 col-12">
                  <label for="" class="form-label">Nombre del certificado: </label>
                  <input type="text"  v-model="selected.name_certificate" class="form-control" placeholder="">
                </div>
                <div class="mb-3 col-12">
                  <label for="" class="form-label">Código del certificado: </label>
                  <input type="text" v-model="selected.cod_certificate" class="form-control" placeholder="">
                </div>
                <div class="mb-3 col-12">
                    <el-upload
                        class="picture-card"
                        ref="courseUpload"
                        action=""
                        drag
                        accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG"
                        :on-change="onUploadChange"
                        :http-request="submit"
                        :multiple="false"
                        :limit="1"
                        :auto-upload="false"
                        :file-list="fileList"
                        :on-exceed="handleExceed"
                    >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">
                        Suelta tu archivo aquí o <em>haz clic para cargar</em>
                        </div>
                        <div slot="tip" class="el-upload__tip">
                        Solo archivos jpg/png con un tamaño menor de 100kb
                        </div>
                    </el-upload>
                </div>
                <div class="text-center">
                  <button type="submit" class="btn btn-primary">Guardar</button>
                </div>
            </div>

            </form>
          </div>
        </div>
      </div>
    </div>


    <el-dialog
      v-model="dialogVisible"
      title="Aviso"
      width="30%"
      :before-close="handleClose"
    >
      <span>Desea borrar este cliente? : <b>{{this.selected.name}}</b></span>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false">Cancelar</el-button>
          <el-button type="danger" @click="deleteObjet()"
            >Confirmar</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment';
import ModalComponent from '../ModalComponent.vue';
import CustomSpinner from '../../common/custom-spinner/CustomSpinner.vue';
import language from '../../api/traduction_es';

export default {
  data() {
    return {
      initialLoading: false,
      moment: moment,
      clientes: [],
      selected: [],
      fileList: [],
      courseCategory: [],
      dialogVisible: false,
      deleteId: null,
    };
  },
  components: {
    'custom-modal': ModalComponent,
    'custom-spinner': CustomSpinner,
  },

  mounted() {
    this.listarClientes();
    this.getDocumentTypes();
    this.listCourseCategory();
  },

  methods: {
    changuePage(){
          location.reload();
    },

    editModal(cliente){
      this.selected = cliente;
      $('#exampleModal').modal('show');
    },

    deleteModal(cliente){
      this.selected = cliente;
      this.dialogVisible = true;
    },

    async deleteObjet() {

        const { data } = await axios.delete(`/clientes-sst/delete/${this.selected.id}`);
        const { status, courses } = await data;
        const response = (await status) == 'ok'
            ? this.$message.success('Se ha eliminado el Cliente correctamente')
            : await this.$message.success('Se ha eliminado el Cliente correctamente');
            this.selected = [];
            $('#delete-course-modal').modal('hide');
            setTimeout(this.changuePage, 2500);
    },

    listCourseCategory() {
      axios
        .get(`/document-types`)
        .then((response) => {
          if (response.data.error) {
            //
          } else {
            Object.keys(response.data).map((key) => {
              this.courseCategory.push(response.data[key]);
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async submit(){
        const formdata = new FormData();
        formdata.append('id', this.selected.id);
        formdata.append('name', this.selected.name);
        formdata.append('lastname', this.selected.lastname);
        formdata.append('doc_type_id', this.selected.doc_type_id);
        formdata.append('num_doc', this.selected.num_doc);
        formdata.append('name_certificate', this.selected.name_certificate);
        formdata.append('cod_certificate', this.selected.cod_certificate);

        if (this.fileList.length > 0) {
          formdata.append('img_certificate', this.fileList[0].raw);
        }
        
        try {
                this.loading = true;
                const request = await axios({
                    url: '/clientes-sst/update',
                    method: 'post',
                    data: formdata,
                    headers: { 'Content-Type': 'multipart/form-data' },
                });
                const response =
                    request.status == 200
                    ? this.$message.success('El cliente SST ha sido registrado correctamente')
                    : await this.$message.warning('Error al validar datos');
                this.isSubmitting = false;
                this.loading = false;
                this.fileList = [];
                this.selected = [];
                $('#exampleModal').modal('hide');
                } catch (error) {
                this.isSubmitting = false;
                this.loading = false;
                console.log(error);
            }
    },
    onUploadChange(file) {
        this.fileList = [];

        const isImage =
            file.raw.type === 'image/jpeg' ||
            file.raw.type === 'image/png' ||
            file.raw.type === 'image/jpg';

        // 100kb
        const isLt1M = file.size < 100000;

        if (!isImage) {
            this.$message.error('Solo puede cargar archivos en formato jpg|jpeg|png.');
            this.$refs.courseUpload.clearFiles();
            return false;
        }
        // if (!isLt1M) {
        //     this.$message.error('El archivo no debe pesar más de 100kb!');
        //     this.$refs.courseUpload.clearFiles();
        //     return false;
        // }
        this.fileList.push(file);
        console.log("archivo");
        console.log(this.fileList);
    },
    handleExceed(file) {
        // const isLt1M = file.size > 100000;

        // if (!isLt1M) {
        //     this.$message.error('El archivo no debe pesar más de 100kb!');
        //     this.$refs.courseUpload.clearFiles();
        //     return false;
        // }
    },
    loadDataTable() {
      $(document).ready( function () {
          $('#data-table-list-courses').DataTable(language);
      } );
    },
    async getDocumentTypes(){
        await axios.get('/document-types').then((response) => {
            this.document_types = response.data;
        });
    },
    listarClientes: function () {
      this.initialLoading = true;
      axios.get(`/clientes-sst/list`).then((response) => {
        console.log(response);
        this.clientes = response.data;
        this.initialLoading = false;
        this.loadDataTable();
      });
    },
  },
};
</script>
<style>
.el-select {
  width: 80%;
}
.el-select .el-input .el-select__caret::before {
  content: '\e794';
}

#customize_select {
  background-color: #ffffff !important;
  border: none !important;
  width: 0px !important;
  font-size: 0px !important;
  justify-content: center;
  text-align: center;
  padding: 0 !important;
}
</style>
